// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__7UBwY","signatureBlock":"Footer_signatureBlock__3XqLm","signature":"Footer_signature__2EhKP"};